import { render, staticRenderFns } from "./StudentLightCourseModules.vue?vue&type=template&id=b133bc3e&scoped=true&"
import script from "./StudentLightCourseModules.vue?vue&type=script&lang=js&"
export * from "./StudentLightCourseModules.vue?vue&type=script&lang=js&"
import style0 from "./StudentLightCourseModules.vue?vue&type=style&index=0&id=b133bc3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b133bc3e",
  null
  
)

export default component.exports